import { useEffect, useRef } from "react";
import { DistributedRewardResponse, NotificationType } from "@devour/client";
import { showCompetitionToast } from "@/components/CompetitionToast";

interface Props {
    reward: DistributedRewardResponse;
    /** Called once the toast has fired, so the reward is not surfaced again. */
    onShown: () => void;
}

/**
 * Fires the `prizePaid` competition toast for a leaderboard win and renders nothing.
 * Only ranks the payout actually paid produce one of these rewards, so it cannot
 * reach a player below the prize line.
 */
export default function LeaderboardWinToast({ reward, onShown }: Props): null {
    const fired = useRef(false);

    useEffect(() => {
        if (fired.current) return;
        const meta = reward.notificationMetadata;
        if (meta?.notificationType !== NotificationType.PRIZE_POOL) return;
        fired.current = true;

        showCompetitionToast("prizePaid", {
            rank: meta.rank,
            boardLabel: meta.challengeName,
            prizeLabel: meta.rewardName,
        });
        onShown();
    }, [reward, onShown]);

    return null;
}
